import { useAliveController } from 'react-activation';
import { useNavigate } from 'react-router-dom';

const useBack = (dropName: string) => {
    const { drop } = useAliveController();
    const link = useNavigate();

    /**
     *
     * @param isDrop - 是否清除列表页面缓存
     */
    const onBack = async (isDrop = true) => {
        isDrop && (await drop(dropName));
        link(-1);
    };
    return { onBack };
};
export default useBack;
